import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/svg/logo.svg'
import _imports_1 from './images/svg/text.svg'
import _imports_2 from './images/svg/reorder-two-sharp.svg'
import _imports_3 from './images/svg/close-sharp.svg'


const _withScopeId = n => (_pushScopeId("data-v-6df65bb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_3
const _hoisted_2 = { class: "main-header" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "header__wrapper container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__title my-auto",
  src: _imports_1,
  alt: "text"
}, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "header__menu" }
const _hoisted_9 = { class: "header__menu__item my-auto" }
const _hoisted_10 = { class: "header__menu__item my-auto" }
const _hoisted_11 = { class: "header__menu__item my-auto" }
const _hoisted_12 = { class: "header__menu__item my-auto" }
const _hoisted_13 = { class: "header__burger-menu my-auto" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "",
  alt: "",
  srcset: _hoisted_1
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

import { defineEmits, defineProps } from "vue/dist/vue";

import VButton from "@/shared/ui/base-components/v-button";
import { router } from "@/app/providers";


export default /*#__PURE__*/_defineComponent({
  __name: 'VHeader',
  props: {
    isSidebarOpen: { type: Boolean }
  },
  emits: ["update:isSidebarOpen"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toogleMenu = () => {
  emit("update:isSidebarOpen", !props.isSidebarOpen);
};

const scrollTo = (id: string) => {
  if (router.currentRoute.value.path !== "/") {
    router.replace({ name: "home", hash: "#" + id });
    // return;
  }

  setTimeout(() => {
    scrollToElementWithOffset(id, 115);
  }, 100);
};

const openMainPageOrScrollToTop = () => {
  if (router.currentRoute.value.path !== "/") {
    router.replace({ name: "home" });
    return;
  }

  console.log("openMainPageOrScrollToTop");

  setTimeout(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, 100);
};

const scrollToElementWithOffset = (elementId: string, offset: number) => {
  let element = document.getElementById(elementId);

  if (element) {
    let elementPosition = element.getBoundingClientRect().top;
    let start = window.pageYOffset;
    let startTime: any = null;

    const scrollAnimation = (currentTime: any) => {
      if (startTime === null) startTime = currentTime;

      let progress: any = currentTime - startTime;
      let easeInOutCubic = (progress: any) =>
        progress < 0.5
          ? 4 * progress ** 3
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      let scrollTo = elementPosition - offset;
      window.scrollTo(0, start + scrollTo * easeInOutCubic(progress / 500));

      if (progress < 500) {
        requestAnimationFrame(scrollAnimation);
      }
    };

    requestAnimationFrame(scrollAnimation);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "header__logo my-auto",
          onClick: openMainPageOrScrollToTop
        }, _hoisted_7),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(VButton), {
              label: "1x_How",
              color: "white",
              "text-color": "dark",
              size: "lg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollTo('how')))
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(VButton), {
              label: "2x_Technology",
              color: "white",
              "text-color": "dark",
              size: "lg",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollTo('technology')))
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(VButton), {
              label: "3x_Do_more",
              color: "white",
              "text-color": "dark",
              size: "lg",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollTo('do-more')))
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(VButton), {
              label: "4x_Get_in_touch",
              color: "white",
              "text-color": "dark",
              size: "lg",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollTo('get-in-touch')))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (!props.isSidebarOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "header__menu-icon",
                onClick: toogleMenu
              }, _hoisted_15))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "header__close-icon",
                onClick: toogleMenu
              }, _hoisted_17))
        ])
      ])
    ])
  ]))
}
}

})